import { useEffect, useRef, useState } from "react";

interface paramsI {
  callback?: Function;
  throttleTime?: number;
}

const useThrottle = () => {
  const [params, setParams] = useState<paramsI>({});
  const callbackThrottle = useRef<ReturnType<typeof setTimeout>>();
  // let callbackThrottle: NodeJS.Timeout;

  useEffect(() => {
    if (typeof params?.callback === "function" && params.throttleTime) {
      if (callbackThrottle.current !== undefined)
        clearTimeout(callbackThrottle.current);
      callbackThrottle.current = setTimeout(() => {
        params.callback!();
      }, params.throttleTime!);
    }
    return () => {
      if (callbackThrottle.current !== undefined)
        clearTimeout(callbackThrottle.current);
    };
  }, [params]);

  return setParams;
};

export default useThrottle;
